__turbopack_context__.v({
  "--has-ad": "sponsored-footer-module-scss-module__JkzvdW__--has-ad",
  "--is-squeezed": "sponsored-footer-module-scss-module__JkzvdW__--is-squeezed",
  "__button-group": "sponsored-footer-module-scss-module__JkzvdW____button-group",
  "__cta-button": "sponsored-footer-module-scss-module__JkzvdW____cta-button",
  "sponsored-footer": "sponsored-footer-module-scss-module__JkzvdW__sponsored-footer",
});
